import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'ProvidersFilter',

  mixins: [ proxy({ type: 'object' }) ],

  render
}
